module.exports = __webpack_public_path__ + "img/rh.da6ac87a.jpg";